import {useCallback} from "react";

import {useWindowEvent} from "../useWindowEvent";

export const useEventHandler = (eventType, callback, dependencies=[]) => {
  // the event will be added and removed if ANY dependencies change
  useWindowEvent(eventType, useCallback(callback, [...dependencies]));
};
